// src/components/question-settings/question-settings.jsx
import React, { useEffect, useState, useMemo } from "react";
import "../Details.css";
import "./Settings.css";
import "./ManageQuestions.css";
import { Link, useParams ,useNavigate} from "react-router-dom";
import Navbar from "../navbar";
import { useAuth } from "../../auth/AuthContext";
import QuestionCategoryNavigationBar from "./QuestionCategoryNavigationBar";

function ManageQuestions() {
  const pageTitle = "Manage Questions";

  const { user,tenantServerUrl, accessToken, selectedRestaurantId } = useAuth();
const [showConfirmSave, setShowConfirmSave] = useState(false);
  // Tenant-specific questions endpoint
  const QUESTIONS_API_URL = useMemo(() => {
    if (!tenantServerUrl) return null;
    return `${tenantServerUrl.replace(
      /\/$/,
      ""
    )}/tablemate/endpoints/statistics/fetchQuestionsBESA.php`;
  }, [tenantServerUrl]);

  // Normalize token to "Bearer <token>"
  const bearerToken = useMemo(() => {
    if (!accessToken) return null;
    return accessToken.startsWith("Bearer ")
      ? accessToken
      : `Bearer ${accessToken}`;
  }, [accessToken]);

const EDIT_QUESTION_API_URL = useMemo(() => {
  if (!tenantServerUrl) return null;
  return `${tenantServerUrl.replace(
    /\/$/,
    ""
  )}/tablemate/endpoints/statistics/editRatingQuestion.php`;
}, [tenantServerUrl]);

  const REDIR_BASE = "https://mydata.tablemate.net/redir.php?url=";

  const buttonsList = [
    {
      categoryID: 6,
      chartID: "1/1",
      title: "Food",
      icon: "reports",
      chartType: "rating_category",
    },
    {
      categoryID: 6,
      chartID: "2/1",
      title: "Atmosphere",
      icon: "reports",
      chartType: "rating_category",
    },
    {
      categoryID: 6,
      chartID: "3/1",
      title: "Service",
      icon: "reports",
      chartType: "rating_category",
    },
  ];
  const urlPrefix = [];

  const {
    questionCategoryID: categoryIDParam,
    questionID: questionIDParam,
  } = useParams();

  const dataCategoryID = "6";
  const categoryID = categoryIDParam || "1";
  const questionID = questionIDParam || "1";

  const RestaurantID = selectedRestaurantId; // for future use if needed

  const [questionsList, setQuestionsList] = useState([]);

  // Modal state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editQuestionText, setEditQuestionText] = useState("");
  const [editType, setEditType] = useState("rating");

  // Fetch questions for this category
  useEffect(() => {
    if (!categoryID || !QUESTIONS_API_URL || !bearerToken) {
      if (!bearerToken) {
        console.log(
          "[ManageQuestions] Skipping questions fetch: no bearerToken yet."
        );
      }
      return;
    }

    const controller = new AbortController();

    async function loadQuestions() {
      try {
        const proxiedUrl = `${REDIR_BASE}${encodeURIComponent(
          QUESTIONS_API_URL
        )}&categoryID=${encodeURIComponent(categoryID)}`;

        console.log("category:", categoryID);
        console.log("Downloading questions:", proxiedUrl);

        const res = await fetch(proxiedUrl, {
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
            Authorization: bearerToken,
          },
        });

        if (!res.ok) {
          const text = await res.text();
          console.error("Failed to load questions:", res.status, text);
          return;
        }

        const data = await res.json();
        console.log("Question list result:", data);

        // Filter out inactive questions
        const activeOnly = (data || []).filter(q => q.active == "1");

        setQuestionsList(activeOnly);
      } catch (err) {
        if (err.name !== "AbortError") {
          console.error("Error loading questions:", err);
        }
      }
    }

    loadQuestions();
    return () => controller.abort();
  }, [categoryID, QUESTIONS_API_URL, bearerToken]);

  // Helpers
  const getQuestionTypeLabel = (type) => {
    switch (type) {
      case "comment":
        return "Comment";
      case "yes":
        return "Yes / No";
      default:
        return "Rating Bar";
    }
  };

  const openEditModal = (q) => {
    setSelectedQuestion(q);
    setEditTitle(q.title || "");
    setEditQuestionText(q.question || "");
    setEditType(q.type || "rating");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedQuestion(null);
  };

  const handleSave = () => {
    if (!selectedQuestion) return;

    const selectedId = String(selectedQuestion.questionID ?? selectedQuestion.id);

    // Update local list so UI reflects changes immediately
    setQuestionsList((prev) =>
      prev.map((q) => {
        const qID = String(q.questionID ?? q.id);
        if (qID !== selectedId) return q;
        return {
          ...q,
          title: editTitle,
          question: editQuestionText,
          type: editType,
        };
      })
    );

    // TODO: plug in API call to save changes on the server

    closeModal();
  };


const handleSaveConfirmed = async () => {
  if (!selectedQuestion) return;

  const selectedId = String(selectedQuestion.questionID ?? selectedQuestion.id);

  // 1) Update UI immediately
  setQuestionsList((prev) =>
    prev.map((q) => {
      const qID = String(q.questionID ?? q.id);
      if (qID !== selectedId) return q;
      return {
        ...q,
        title: editTitle,
        question: editQuestionText,
        type: editType,
      };
    })
  );

  // 2) Call backend PHP to persist
  try {
    if (!EDIT_QUESTION_API_URL || !bearerToken) {
      console.warn(
        "[ManageQuestions] Missing EDIT_QUESTION_API_URL or bearerToken."
      );
    } else {
      // helper for PHP's "__" space hack
      const encodeForPhp = (value) =>
        String(value ?? "").replace(/ /g, "__");

      const questionCategory =
        selectedQuestion.category ??
        selectedQuestion.question_category ??
        categoryID;

      const questionNumber =
        selectedQuestion.question_number ??
        selectedQuestion.id ??
        "";

      const byWho =
        user?.name ||
        user?.fullName ||
        user?.email ||
        user?.username ||
        "Manager";

      const params = new URLSearchParams({
        question_title: encodeForPhp(editTitle),
        question: encodeForPhp(editQuestionText),
        question_category: encodeForPhp(questionCategory),
        question_number: encodeForPhp(questionNumber),
        question_type: encodeForPhp(editType),
        bywho: encodeForPhp(byWho),
      });

      const proxiedUrl = `${REDIR_BASE}${encodeURIComponent(
        EDIT_QUESTION_API_URL
      )}&${params.toString()}`;

      console.log("[ManageQuestions] Saving question via:", proxiedUrl);

      const res = await fetch(proxiedUrl, {
        method: "GET",
        headers: {
          Authorization: bearerToken,
        },
      });

      const text = await res.text();
      console.log("[ManageQuestions] Save result:", text);

      if (!res.ok || !text.toLowerCase().includes("success")) {
        console.error("Save failed:", res.status, text);
        // TODO: surface toast / error message to user
      }
    }
  } catch (err) {
    console.error("Error saving question:", err);
    // TODO: show error toast
  }

  // 3) Close modals
  setShowConfirmSave(false);
  closeModal();
};


 const navigate = useNavigate();
  // Normalize route: /data/6/:categoryID -> /data/6/:categoryID/1
    useEffect(() => {
      if (categoryID && !questionIDParam) {
        navigate(`/settings/questions/${dataCategoryID}/${categoryID}/1`, { replace: true });
      }
    }, [categoryID, questionIDParam, dataCategoryID, navigate]);
  return (
    <div className="details-container-page">
      <Navbar pageTitle={pageTitle} onToggleSidebar={true} />

      <div className="details-main">
        <div className="question-settings-column">
          {/* Category navigation */}
          <section className="question-settings-card">
            <QuestionCategoryNavigationBar
              buttonsList={buttonsList}
              urlPrefix={urlPrefix}
            />
          </section>

          {/* Manage Rating Questions */}
          <section className="question-settings-card question-settings-card-actions">
            <div className="question-settings-card-header">
              <div>
                <h2 className="question-settings-card-title">
                  Manage Rating Questions
                </h2>
                <p className="question-settings-card-subtitle">
                  Select a question below to edit the text your guests see in
                  the Table Mate! app.
                </p>
              </div>
            </div>

            <span className="settings-label">
                <i>
                  * Changing a question&apos;s content will start a new rating
                  thread, meaning that the previous question and its responses
                  will be self-contained in the Data Centre; new question will also be
                  self-contained in the Data Centre to avoid data ambiguity.{" "}
                </i>
                <a
                  href="https://support.tablemate.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn More
                </a>
              </span>
              <br></br>   <br></br>
              <Link
                to="/data/6/0/0"
                className="tm-btn tm-btn-dark tm-btn-full"
              >
                Browse Question Response Data
              </Link>
            <div
              id="rating-questions-list"
              className="rating-questions-list"
              style={{ marginTop: "16px" }}
            >
              {questionsList && questionsList.length > 0 ? (
                questionsList.map((q) => {
                  const qID = q.questionID ?? q.id;
                  const isActive = String(qID) === String(questionID);
                  const statusActive = q.active == "1" || q.active == "2";
                  const typeLabel = getQuestionTypeLabel(q.type);
                  const questionNumber = q.question_number || qID;

                  return (
                    <div
  key={q.id ?? qID}
  className={`tm-question-row ${isActive ? "tm-question-row-selected" : ""}`}
  onClick={() => openEditModal(q)}
>
  {/* Left icon / number */}
  <div className="tm-q-leading">
    <div className="tm-q-circle">
      {questionNumber}
    </div>
  </div>

  {/* Main content */}
  <div className="tm-q-content">
    <div className="tm-q-title-row">
      <span className="tm-q-title">
        {q.title || "Untitled question"}
      </span>
     
      <span className="tm-q-type-pill">
        {typeLabel === "Rating Bar" && "⭐ Rating"}
        {typeLabel === "Comment" && "💬 Comment"}
        {typeLabel === "Yes / No" && "✔ Yes / No"}
        {!["Rating Bar", "Comment", "Yes / No"].includes(typeLabel) &&
          typeLabel}
      </span>
    </div>
 <div>{q.question}</div>
    <div className="tm-q-meta-row">
      <span
        className={`tm-q-status-dot ${
          statusActive ? "tm-q-status-dot-active" : "tm-q-status-dot-inactive"
        }`}
      />
      <span className="tm-q-status-label">
        {statusActive ? "Active" : "Inactive"}
      </span>
      <span className="tm-q-id-label">Question #{questionNumber}</span>
    </div>
  </div>

  {/* Right-side chevron + subtle deep link */}
  <div
    className="tm-q-actions"
    onClick={(e) => e.stopPropagation()}
  >
    <Link
      to={`/settings/questions/${dataCategoryID}/${categoryID}/${qID}`}
      className="tm-q-open-link"
      title="Open in full page"
    >
      ↗
    </Link>
    <span className="tm-q-chevron">›</span>
  </div>
</div>

                  );
                })
              ) : (
                <p className="question-settings-empty">
                  No questions found for this category.
                </p>
              )}
            </div>
          </section>
        </div>
      </div>

      



      {/* EDIT MODAL */}
      {isModalOpen && selectedQuestion && (
        <div className="tm-modal-backdrop" onClick={closeModal}>
          <div
            className="tm-modal"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "700px" }}
          >
            <div className="tm-modal-header">
              <h3 className="tm-modal-title">
                Edit Rating Question{" "}
                {selectedQuestion.question_number ??
                  selectedQuestion.questionID ??
                  selectedQuestion.id}
              </h3>
              <button
                className="tm-modal-close-btn"
                type="button"
                onClick={closeModal}
              >
                ✕
              </button>
            </div>

            <div className="tm-modal-body">
              {/* Current question summary */}
              <p>
                <strong>Question Title: </strong>
                <em>{selectedQuestion.title || "Untitled"}</em>
              </p>
              <p>
                <strong>Question: </strong>
                <em>{selectedQuestion.question || "—"}</em>
              </p>
              <p>
                <strong>Question Type: </strong>
                <em>{getQuestionTypeLabel(selectedQuestion.type)}</em>
              </p>

              <p
                style={{
                  marginTop: "12px",
                  marginBottom: "16px",
                  fontSize: "0.9rem",
                }}
              >
                <em>
                  <span className="settings-label">
                <i>
                  * Changing a question&apos;s content will start a new rating
                  thread, meaning that the previous question and its responses
                  will be self-contained in the Data Centre; new question will also be
                  self-contained in the Data Centre to avoid data ambiguity.{" "}
                </i>
                <a
                  href="https://support.tablemate.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn More
                </a>
              </span>
                </em>
              </p>

              {/* Editable fields */}
              <div className="tm-form-group">
                <label>
                  Question Title:{" "}
                  <span className="tm-label-hint">
                    <i>Keep short and descriptive, 1 or 2 words</i>
                  </span>
                </label>
                  <br></br>
                <input
                  className="tm-input"
                  type="text"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                />
              </div>

              <div className="tm-form-group">
                <label>
                  Question:{" "}
                  <span className="tm-label-hint">
                    <i>Full question that client will answer</i>
                  </span>
                </label>
                  <br></br>
                <textarea
                  className="tm-input"
                  type="text"
                  value={editQuestionText}
                  onChange={(e) => setEditQuestionText(e.target.value)}
                />
              </div>

              <div className="tm-form-group">
                <label>
                  Question Type:{" "}
                  <span className="tm-label-hint">
                   <i> 5 Star Rating Bar, Yes/No or Comment</i>
                  </span>
                </label>
                  <br></br>
                <select
                  className="tm-input"
                  value={editType}
                  onChange={(e) => setEditType(e.target.value)}
                >
                  <option value="rating">Rating Bar</option>
                  <option value="yes">Yes / No</option>
                  <option value="comment">Comment</option>
                </select>
              </div>
            </div>
  <br></br>
            <div className="tm-modal-footer">
              <button
                type="button"
                className="tm-btn tm-btn-secondary"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="button"
                className="tm-btn tm-btn-primary"
                  onClick={() => setShowConfirmSave(true)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}


        {showConfirmSave && (
  <div className="tm-modal-backdrop" onClick={() => setShowConfirmSave(false)}>
    <div
      className="tm-modal"
      onClick={(e) => e.stopPropagation()}
      style={{ maxWidth: "600px" }}
    >
      <div className="tm-modal-header">
        <h3 className="tm-modal-title">Confirm Save</h3>
        <button
          className="tm-modal-close-btn"
          type="button"
          onClick={() => setShowConfirmSave(false)}
        >
          ✕
        </button>
      </div>

      <div className="tm-modal-body">
        <p>
          Are you sure you want to save changes to this question?
          <br />
          <br />
          <i>
                  * Changing a question&apos;s content will start a new rating
                  thread, meaning that the previous question and its responses
                  will be self-contained in the Data Centre in; new question will also be
                  self-contained in the Data Centre to avoid data ambiguity.{" "}
                </i>
                <a
                  href="https://support.tablemate.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn More
                </a>
        </p>
      </div>

      <div className="tm-modal-footer">
        <button
          type="button"
          className="tm-btn tm-btn-primary"
          onClick={() => handleSaveConfirmed()}
        >
          Yes
        </button>

        <button
          type="button"
          className="tm-btn tm-btn-secondary"
          onClick={() => setShowConfirmSave(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default ManageQuestions;
